import _classCallCheck from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */
import * as LogLevelModule from 'loglevel';
import { PACKAGE_NAME } from './constants';
/**
 * {@link Log} provides logging features throughout the sdk using loglevel module
 * See https://github.com/pimterry/loglevel for documentation
 * @private
 */

var Log = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param [tag] - tag name for the logs
   * @param [options] - Optional settings
   */
  function Log(tag, options) {
    _classCallCheck(this, Log);

    this._log = Log.getLogLevelInstance(options);
    this._prefix = "[TwilioVoice][".concat(tag, "]");
  }
  /**
   * Return the `loglevel` instance maintained internally.
   * @param [options] - Optional settings
   * @returns The `loglevel` instance.
   */


  _createClass(Log, [{
    key: "debug",
    value:
    /**
     * Log a debug message
     * @param args - Any number of arguments to be passed to loglevel.debug
     */
    function debug() {
      var _this$_log;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_this$_log = this._log).debug.apply(_this$_log, [this._prefix].concat(args));
    }
    /**
     * Log an error message
     * @param args - Any number of arguments to be passed to loglevel.error
     */

  }, {
    key: "error",
    value: function error() {
      var _this$_log2;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      (_this$_log2 = this._log).error.apply(_this$_log2, [this._prefix].concat(args));
    }
    /**
     * Log an info message
     * @param args - Any number of arguments to be passed to loglevel.info
     */

  }, {
    key: "info",
    value: function info() {
      var _this$_log3;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      (_this$_log3 = this._log).info.apply(_this$_log3, [this._prefix].concat(args));
    }
    /**
     * Set a default log level to disable all logging below the given level
     */

  }, {
    key: "setDefaultLevel",
    value: function setDefaultLevel(level) {
      if (this._log.setDefaultLevel) {
        this._log.setDefaultLevel(level);
      } else {
        // tslint:disable-next-line
        console.warn('Logger cannot setDefaultLevel');
      }
    }
    /**
     * Log a warning message
     * @param args - Any number of arguments to be passed to loglevel.warn
     */

  }, {
    key: "warn",
    value: function warn() {
      var _this$_log4;

      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      (_this$_log4 = this._log).warn.apply(_this$_log4, [this._prefix].concat(args));
    }
  }], [{
    key: "getLogLevelInstance",
    value: function getLogLevelInstance(options) {
      if (!Log.loglevelInstance) {
        try {
          Log.loglevelInstance = (options && options.LogLevelModule ? options.LogLevelModule : LogLevelModule).getLogger(PACKAGE_NAME);
        } catch (_a) {
          // tslint:disable-next-line
          console.warn('Cannot create custom logger');
          Log.loglevelInstance = console;
        }
      }

      return Log.loglevelInstance;
    }
  }]);

  return Log;
}();
/**
 * Log levels
 */


Log.levels = LogLevelModule.levels;
export var Logger = Log.getLogLevelInstance();
export default Log;